<template>
  <div id="app" v-cloak>
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Footer,
  }
}
</script>

<style>
body,
html {
  color: #686868;
}

[v-cloak] {
    display: none;
}

main {
  margin: 50px 0;
}

header {
  margin: 25px;
}

a {
  color: #df6f1c;
}

a:hover {
  color: #54595f;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Rubik", sans-serif;
  font-weight: bold;
  color: #54595f;
}

.navegacao {
  background-color: #df6f1c;
  border-style: none;
  border-radius: 5px;
}

.navbar-dark .navbar-nav .nav-link {
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.85em;
  line-height: 1;
  margin: 0 20px;
}

.dropdown-menu {
  background-color: #bf590e !important;
  border-style: none;
}

.dropdown-item {
  color: #fff;
}

.dropdown-item:hover {
  background-color: #bc580e;
  color: #eaa572;
}

.laranja {
  background-color: #e99a60;
  padding: 25px;
  color: #fff;
}

.laranja h1,
.laranja h2 {
  color: #fff;
}

.laranja a {
  color: #fff;
  font-weight: bold;
}

.laranja a:hover {
  color: #f3cab5;
}

.textura {
  background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.89),
      rgba(255, 255, 255, 0.89)
    ),
    url("assets/textura.png");
  background-repeat: repeat;
  background-size: 48% auto;
  background-color: rgba(255, 255, 255, 0.4);
  padding: 50px 0;
  margin: 50px 0;
}

.copy {
  background-color: #df6f1c;
  padding: 25px;
  color: #fff;
}

.copy a {
  color: #fff;
  font-weight: bold;
}

.copy a:hover {
  color: #f3cab5;
}

@media (max-width: 768px) {
  .textura {
    background-size: 200% auto;
  }
}

[v-cloak] {
  display: none;
}

.form-control.is-valid {
  background-image: none;
}

.form-control.is-invalid {
  background-image: none;
}

.navbar-dark .navbar-nav .nav-link {
  cursor: pointer;
}

.alert-enter-active,
.alert-leave-active {
  transition: opacity 0.5s;
}

.alert-enter,
.alert-leave-to

/* .alert-leave-active em versões anteriores a 2.1.8 */
 {
  opacity: 0;
}
</style>
